import React from "react";
import { SiteMetadata } from "@/hooks/SiteMetadata";

const thumbnail = "/images/thumbnail.webp";

interface SeoProptypes {
  metaDescription?: string;
  metatitle?: string;
  seoDescription?: string;
  seoTitle?: string;
  SeoImage?: string;
  seoType?: string;
  SeoUrl?: string;
  children?: any;
}

export const Seo: React.FC<SeoProptypes> = ({
  metatitle,
  metaDescription,
  seoType,
  seoTitle,
  seoDescription,
  SeoImage,
  SeoUrl,
  children,
}) => {
  const { title, description, siteUrl } = SiteMetadata();
  return (
    <>
      <title>{metatitle ? metatitle : title}</title>
      <meta name="robots" content="max-snippet:-1"></meta>
      <meta name="robots" content="max-image-preview:standard"></meta>
      <meta
        name="image"
        content={
          SeoImage
            ? `${process.env.GATSBY_SITE_URL}${SeoImage}`
            : `${process.env.GATSBY_SITE_URL}${thumbnail}`
        }
      />
      <meta
        name="description"
        content={metaDescription ? metaDescription : description}
      />

      <meta property="og:type" content={seoType ? seoType : "article"} />
      <meta property="og:title" content={seoTitle ? seoTitle : title} />
      <meta
        property="og:url"
        content={
          SeoUrl
            ? `${process.env.GATSBY_SITE_URL}${SeoUrl}`
            : `${process.env.GATSBY_SITE_URL}${siteUrl}`
        }
      />
      <meta
        property="og:image"
        content={
          SeoImage
            ? `${process.env.GATSBY_SITE_URL}${SeoImage}`
            : `${process.env.GATSBY_SITE_URL}${thumbnail}`
        }
      />
      <meta
        property="og:description"
        content={seoDescription ? seoDescription : description}
      />
      <meta
        name="facebook-domain-verification"
        content="rl09cticmnyn7wb4ghlqfxg83g5djf"
      />
      {children}
    </>
  );
};
